import type { StatementsProvider } from '@/src/app/main/(tabs)/card/card-management/statements'
import { useLogError } from '@/src/common/hooks/useLogError'
import { useLoggedInQuery } from '@/src/common/gql/MesaGql'
import { GET_STATEMENTS } from '@/src/common/gql/queries/card'

export const LegacyStatements = (({ ToWrap }) => {
  const logError = useLogError()
  const { data, loading, error } = useLoggedInQuery(GET_STATEMENTS, {
    fetchPolicy: 'no-cache',
    onError: logError,
  })

  return <ToWrap statements={data?.getStatements} loading={loading} error={!!error} />
}) satisfies StatementsProvider
